<template>
  <v-row class="mt-10">
    <v-col cols="12">
      <div class="flex-container">
        <!-- Tümünü Getirecek Butonu Üst Componente Yollayan Emit -->
        <v-btn large color="success" @click="$emit('listAll')">tümü</v-btn>
        <div v-for="(letter, index) in letters" :key="index">
          <!-- Tıklanan harfi yakalayıp üst componente eventi yollayan emit -->
          <a href="javascript:void(0)" @click="$emit('clickLetter', letter)">{{ letter }}</a>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      letters: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "İ", "J", "K", "L", "M", "N", "O", "Ö", "P", "R", "S", "Ş", "T", "U", "Ü", "V", "Y", "Z"]
    }
  }
}
</script>

<style></style>
